import { clientAxios } from '@/plugins/axios'

const baseURL = '/v1/order'

export const order = (payload) => clientAxios.post(`${baseURL}/public/new`, payload)

export const validEmail = (payload) => clientAxios.post(`${baseURL}/validates-data`, payload)

export const getOrderList = (params) => clientAxios.get(`${baseURL}/public/list`, { params })
